import React, { FC, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<SVGSVGElement> {
  className?: string;
  size?: number;
  color?: string;
}

export const CopyIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"></path>
    </svg>
  );
};
